import React, { Component } from 'react';
import Container from 'react-bootstrap/Container';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import queryString from 'query-string';

import logo from '../../assets/allWesternCanada.png';
import skLogo from '../../assets/sk_headerlogo.png';
import abLogo from '../../assets/ab_headerlogo.png';

import appStoreBadge from '../../assets/US/Download_on_App_Store/Black_lockup/SVG/Download_on_the_App_Store_Badge_US-UK_RGB_blk_092917.svg';
import playStoreBadge from '../../assets/google-play-badge.png';

import './styles.css';

const APPLE_URL = 'https://apps.apple.com/ca/app/allsaskatchewan/id1591958633';
const GOOGLE_URL = 'https://play.google.com/store/apps/details?id=com.allsaskatchewan.app';

const alert = withReactContent(Swal);

const alertText =
  <p>
    <b>allWestern</b> is now exclusively
    available for mobile devices on the appropriate app store.
  </p>;

export default class extends Component {
  constructor(props) {
    super(props);

    this.state = {
      params: {
        notice: undefined,
        redirect: undefined,
      },
    };
  }

  getQuery() {
    const query = this.props.location.search;
    const params = query ? queryString.parse(query) : {};
    this.setState({params});
  }

  fireNotice() {
    alert.fire({
      type: 'info',
      html: alertText
    });
  }

  _showSubBrand() {
    return (
      <Row className='smaller_logo_container'>
        <Col lg={6} md={4} sm={12}>
          <a href='https://allsaskatchewan.com/'>
            <img className='sk_logo' src={skLogo} alt='skLogo'/>
          </a>
        </Col>

        <Col lg={4} md={6} sm={12} className='ab_logo_container'>
          <a href='https://allalberta.com/'>
            <img className='ab_logo' src={abLogo} alt='abLogo'/>
          </a>
        </Col>
      </Row>
    );
  }

  _downloadApp() {
    return (
      <Row className='justify-content-center'>
        <Col lg={5} md={7} sm={10} className='download_text_container'>
          <p>
            allWestern subscribers have been
            directed to this website to download our
            new app. Please follow the link below for a better mobile
            experience.
          </p>
        </Col>
      </Row>
    );
  }

  render() {
    // Remove this when google app is back up.
    // const { googleHovered } = this.state || {};


    return (
      <Container>
        <Row  className='logo_container'>
            <img  src={logo} className='logo' alt='allWestern-logo'/>
        </Row>

        {this.state.params.redirect ? this._downloadApp() :
          this._showSubBrand()}

        <Row className='badges align-items-start'>
          <Col lg={5} md={5} sm={5} className='apple_badge'>
            <a href={APPLE_URL}>
              <img src={appStoreBadge} className='store_badge'
                alt='appStore-badge'/>
            </a>
          </Col>
          <Col className='spacer'/>
          <Col 
            lg={5} md={5} sm={5} 
            className='google_badge'
            // onMouseEnter={() => this.setState({ googleHovered: true })} // Remove when google app is back.
            // onMouseLeave={() => this.setState({ googleHovered: false })} // Remove when google app is back.
          >
            {/*  Uncomment when google app is back up */}
            <a href={GOOGLE_URL}>
              <div style={{ position: 'relative', display: 'inline-block' }}>
                <img src={playStoreBadge} className='store_badge'
                  alt='appStore-badge'
                  style={{ cursor: 'pointer' }}
                />
                {/* </a> */}

                {/* Remove this when google app is back up */}
                {/* {(googleHovered) ? */}
                  <div
                    style={{
                      position: 'absolute',
                      top: '100%', // below image
                      left: '50%',
                      transform: 'translateX(-50%)',
                      background: 'rgba(0, 0, 0, 0.85)',
                      color: 'white',
                      padding: '10px',
                      borderRadius: '8px',
                      width: '250px',
                      zIndex: 2,
                      textAlign: 'left',
                    }}
                  >
                    <p style={{ margin: 0, fontSize: '0.9rem' }}>
                      We have updated our app to support the latest Android version. Please visit the app store to get the latest version.
                      {/* Please click{' '}   */}
                      {/* <a
                        href="https://allSaskatchewan.com"
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ color: '#4da3ff', textDecoration: 'underline' }}
                      >
                        allSaskatchewan.com
                      </a>{' '}
                        and{' '}
                      <a
                        href="https://allAlberta.com"
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ color: '#4da3ff', textDecoration: 'underline' }}
                      >
                        allAlberta.com
                      </a>{' '} */}
                        {/* to read the service on your Android phone. */}
                    </p>
                  </div>
                {/* : null } */}
              </div>
            </a>
          {/* Remove here and up when google app is back up */}
          </Col>
        </Row>
      </Container>
    );
  }

  componentDidMount() {
    this.getQuery();
  }

  componentDidUpdate() {
    if (this.state.params && this.state.params.notice) this.fireNotice();
  }
}